import React from "react";
import "../../../../ui-styles/scroll/horizontalScroll.css";


const PosterSlider = (props) => {


    return (
        <>
            {/* <div className="posterHdngRow">
                <span className="posterHdngtxt">{l.banners}</span>
            </div>
            <div className="hztlSliderCntnr">
                <div className="innerSlideCntnr">
                    <div className="postarGroup">
                        <div className="postarItem">
                            <img src={props.data.url} alt="images"/>
                        </div>
                    </div>
                </div>
            </div> */}
            <div className="imgCard" onClick={props.openBnrMobal}>
                <div className="cardMediaImg">
                    <img src={props.data.uploadkey ? `https://${process.env.REACT_APP_s3}.s3.${process.env.REACT_APP_s3Region}.amazonaws.com/${props.data.uploadkey}` : props.data.url} alt="coverimg" />
                    {/* <div className="cardMdaHdr">
                        <span className="cardHdngtxt">{props.data.uploadname}</span>
                    </div> */}
                </div>
            </div>

        </>
    )
}
export default PosterSlider;